import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { updateDocumentNote } from 'src/app/compliance/store/actions/compliance-note.actions';
import {
    addDocumentNoteFailure,
    addDocumentNoteSuccess
} from 'src/app/compliance/store/actions/document-batch-details.actions';
import { DocumentUploadToolClient } from '../../api/document-upload-tool-client.service';

@Injectable()
export class ComplianceNoteEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly documentUploadToolClient: DocumentUploadToolClient
    ) {}

    updateDocumentNote$ = createEffect(() =>
        this._actions$.pipe(
            ofType(updateDocumentNote),
            switchMap((action) => {
                return this.documentUploadToolClient
                    .updateCandidateDocumentNote(action.candidateDocumentId, action.noteId, action.note)
                    .pipe(
                        map((result) => addDocumentNoteSuccess({ result: result })),
                        catchError((result) => of(addDocumentNoteFailure({ error: result })))
                    );
            })
        )
    );
}
